
import React from "react";
import pic5 from "../assets/experience.png";
import pic6 from "../assets/education.png";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const About = () => {
  const { t } = useTranslation();
  return (
    <section id="about">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
      >
        <p className="section__text__p1">{t("about_subtitle")}</p>
        <h1 className="title">{t("about_title")}</h1>
      </motion.div>
      <div className="section-container">
        <div className="about-details-container">
          <div className="about-containers">
            <motion.div 
              className="details-container card-hover"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              whileHover={{ y: -6, scale: 1.02 }}
            >
              <img src={pic5} alt="Experience icon" className="icon" />
              <h3>{t("about_exp_label")}</h3>
              <p>{t("about_exp_value")} <br /> {t("about_exp_field")}</p>
            </motion.div>
            <motion.div 
              className="details-container card-hover"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              whileHover={{ y: -6, scale: 1.02 }}
            >
              <img src={pic6} alt="Education icon" className="icon" />
              <h3>{t("about_edu_label")}</h3>
              <p>{t("about_edu_school1")} <br /> {t("about_edu_school2")}</p>
            </motion.div>
          </div>
          <motion.div 
            className="text-container"
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <p>{t("about_bio")}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
